<template>
    <div ref="scrollPlan" style="padding-bottom: 40px">
        <CFTitle title="20. Plan de achiziții"></CFTitle>
        <div class="document-info">
            <div>
                <p class="subtitle"><strong>ATENȚIE!</strong> Nerespectarea de către beneficiar a prevederilor legislației naționale / europene aplicabile în domeniul achizițiilor conduce la aplicarea de corecții financiare / reduceri procentuale conform legislației în vigoare. În acest sens, solicitantul/beneficiarul va acorda o atenție deosebită pentru a nu diviza achizițiile, înclusiv în domeniul serviciilor de consultanță, cu scopul evitării procedurii competitive prevăzute de Ordinului Ministerului Fondurilor Europene nr. 1284 din 08.08.2016,  cu modificările şi completările ulterioare.</p>
                <p class="subtitle"><strong>Ce înseamnă mai exact acest lucru?</strong> Practic, cheltuielile ce vizează aceeași clasă / categorie CPV trebuie realizate într-o singură achiziție.
                    Dacă valoarea unei cheltuieli este mai mare de 135.060 lei (fără TVA) pentru contractele de furnizare/servicii și mai mare de 450.200 lei (fără TVA) pentru contractele de lucrări, aceasta poate reprezenta o achiziție de sine stătătoare. Vezi exemple mai jos:</p>
            </div>
            <a href="/documents/Ordin_MFE_1284.pdf" download class="document-download">
                <font-awesome-icon icon="file-pdf"></font-awesome-icon>
                <p>Descarcă Ordin<br>MFE_1284</p>
            </a>
        </div>
        <div class="bottom-pictures">
            <img src="@/assets/images/M3/M3Sketch/achizitii-left.png" alt="">
            <img src="@/assets/images/M3/M3Sketch/achizitii-right.png" alt="">
        </div>

        <div class="purple-title-bar mt-5">
            <h3>Configurează achizițiile proiectului</h3>
            <a class="add-button" @click="addSpending()">
                <p>Adaugă o achiziție nouă</p>
                <b-icon-plus-circle-fill font-scale="1.2"></b-icon-plus-circle-fill>
            </a>
        </div>
        <validation-observer #default="{ invalid }" ref="formAchizitii">
            <span class="display-none">{{ invalid }}</span>
            <div v-for="(spending, key) in spendings" :key="key" class="achizitie">
                <div class="achizitie-header" @click="spending.opened = !spending.opened">
                    <h3>{{ spending.title }}</h3>
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                        <b-icon-chevron-down v-if="!spending.opened" font-scale="1.2" class="expand-icon"></b-icon-chevron-down>
                        <b-icon-chevron-up v-else font-scale="1.2" class="expand-icon"></b-icon-chevron-up>
                        <b-icon-x-circle-fill class="delete-icon" @click.stop="deleteSpending(key)"></b-icon-x-circle-fill>
                    </div>
                </div>

                <div v-show="spending.opened" class="achizitie-body">
                    <div class="flex space-between items-center">
                        <div class="flex-column left-input items-center">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group label-cols="12" label-cols-lg="4" label="Titlu achiziție">
                                    <b-form-input
                                        id="cui"
                                        v-model="spending.title"
                                        :state="errors.length > 0 ? false : null"
                                        name="cui"
                                        type="text"
                                        :readonly="completed"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>

                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group label-cols="12" label-cols-lg="4" label="Descriere achiziție">
                                    <b-form-input
                                        id="cui"
                                        v-model="spending.description"
                                        :state="errors.length > 0 ? false : null"
                                        name="cui"
                                        type="text"
                                        :readonly="completed"
                                        @keyup="limitCharacters(key)"
                                    ></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>

                            <div class="fake-input-group" style="width: 100%; align-items: flex-start !important;">
                                <p class="custom-legend col-lg-4 col-12">Selectează cheltuieli</p>
                                <div class="spendings-box" :class="completed ? 'completed-box' : ''">
                                    <b-form-checkbox
                                        v-for="(item, key2) in allSpendings"
                                        :key="key2"
                                        v-model="spending.spendings"
                                        :value="{'id': item.acquisitionId, 'description': item.description, 'total': item.total, 'total_cu_tva': item.total_cu_tva, 'eligible': item.eligible, 'neeligible': item.neeligible}"
                                        :name="item.acquisitionId ? item.acquisitionId.toString() : '-'"
                                        inline
                                        :disabled="completed"
                                        :class="[checkItemIsUsed(item.acquisitionId) ? 'used-item' : '', !checkSpendingIncludes(spending, item) ? 'no-actions' : '']"
                                        class="flex-price"
                                        @change="calculateTotalPrice(spending); toggleUsed(item)"
                                    >
                                        <span :id="'spending' + item.acquisitionId">{{ item.description.substring(0,35) }}<span v-if="item.description.length > 35">...</span></span>
                                        <span>{{ item.total.toFixed(2) }} lei</span>
                                        <b-tooltip :target="'spending' + item.acquisitionId" triggers="hover" placement="left">{{ item.description }}</b-tooltip>
                                    </b-form-checkbox>
                                </div>
                            </div>

                            <div class="fake-input-group" style="width: 100%; margin-top: 15px">
                                <p class="custom-legend col-lg-4 col-12">Valoare contract</p>
                                <div class="green-box">
                                    <p><strong>{{ spending.value ? spending.value.toFixed(2) : 0 }} lei</strong> (fără TVA)</p>
                                </div>
                            </div>

                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                style="margin-top: 15px"
                            >
                                <b-form-group label-cols="12" label-cols-lg="4" label="Dată publicare procedură">
                                    <b-form-datepicker
                                        v-model="spending.date_published"
                                        class="w-100"
                                        locale="ro"
                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                        placeholder="Selectează o dată"
                                        :state="errors.length > 0 ? false : null"
                                        :class="{ 'completed': completed }"
                                    ></b-form-datepicker>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>

                            <b-form-group label-cols="12" label-cols-lg="4" label="Dată publicare rezultat" style="width: 100%">
                                <b-form-datepicker
                                    v-model="spending.date_published_result"
                                    class="w-100"
                                    locale="ro"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    placeholder="Selectează o dată"
                                    :class="{ 'completed': completed }"
                                ></b-form-datepicker>
                            </b-form-group>
                        </div>
                        <div class="flex-column right-input items-center">
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group label-cols="12" label-cols-lg="4" label="Tip contract">
                                    <v-select
                                        v-model="spending.contract"
                                        class="changeCompany"
                                        dir="ltr"
                                        :options="contractTypes"
                                        :reduce="(option) => option.value"
                                        :class="[errors.length > 0 ? 'is-invalid' : '', completed ? 'disabled-select' : '']"
                                        label="label"
                                        input-id="id"
                                        @input="spending.contract === 'lucrari' ? spending.acquisitionLimit = 450200 : spending.acquisitionLimit = 135060; calculateTotalPrice(spending)"
                                    >
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                            >
                                <b-form-group label-cols="12" label-cols-lg="4" label="Coduri CPV">
                                    <v-select
                                        v-model="spending.cpv"
                                        class="changeCompany hiddenValues"
                                        dir="ltr"
                                        :options="getCPVCodes()"
                                        :reduce="(option) => option.id"
                                        :class="[errors.length > 0 ? 'is-invalid' : '', completed ? 'disabled-select' : '']"
                                        label="label"
                                        input-id="id"
                                        :clearable="true"
                                        :close-on-select="true"
                                        :multiple="true"
                                        @input="limitInput"
                                    >
                                        <span slot="no-options" style="font-size: 13px;">Nu există rezultate</span>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                            <div class="fake-input-group" style="width: 100%; align-items: flex-start !important;">
                                <p class="custom-legend col-lg-4 col-12">Coduri CPV selectate</p>
                                <div class="spendings-box" :class="completed ? 'completed-box' : ''">
                                    <p v-for="(item, key3) in spending.cpv" :key="key3" class="cpv-item">
                                        <img src="@/assets/images/M3/M3Sketch/checkmark.png" class="checked-icon">
                                        {{ item }}
                                        <b-icon-x-circle-fill class="delete-cpv" @click="removeCPV(spending, key3)"></b-icon-x-circle-fill>
                                    </p>
                                </div>
                            </div>
                            <div class="fake-input-group" style="width: 100%; margin-top: 15px">
                                <p class="custom-legend col-lg-4 col-12">Tip achiziție</p>
                                <div class="green-box">
                                    <p><strong>{{ spending.type }}</strong></p>
                                </div>
                            </div>
                            <validation-provider
                                #default="{ errors }"
                                rules="required"
                                style="margin-top: 15px"
                            >
                                <b-form-group label-cols="12" label-cols-lg="4" label="Dată semnare contract">
                                    <b-form-datepicker
                                        v-model="spending.date_signed"
                                        class="w-100"
                                        locale="ro"
                                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                        placeholder="Selectează o dată"
                                        :state="errors.length > 0 ? false : null"
                                        :class="{ 'completed': completed }"
                                    ></b-form-datepicker>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>

                            <b-form-group label-cols="12" label-cols-lg="4" label="Dată transmitere J.O.U.E" style="width: 100%">
                                <b-form-datepicker
                                    v-model="spending.date_joue"
                                    class="w-100"
                                    locale="ro"
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                    placeholder="Selectează o dată"
                                    :class="{ 'completed': completed }"
                                ></b-form-datepicker>
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
            <p v-if="unusedSpendings" style="font-size: 14px; text-align: center; margin-top: 20px; color: #ea8196; font-weight: bold">Există una sau mai multe achiziții neatribuite.</p>
        </validation-observer>
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            style="margin-bottom: -40px;"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
        <p id="scrollAuxiliary" style="display: none; margin-top:600px">&nbsp;</p>
        <ChangeRoutePopup :schimbaModal="showModal"
                          @hideTempModal="showModal = false"
                          @changeRoute="leavePage($event)"
                          @achizitiiChanged="$emit('achizitiiChanged')"
        ></ChangeRoutePopup>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import { BFormRadio, BFormInput, BFormCheckbox, BFormGroup, BFormDatepicker, BFormCheckboxGroup, BIconPlusCircleFill, BIconChevronUp, BIconChevronDown, BIconXCircleFill, BTooltip } from "bootstrap-vue";
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import {limitWords} from '@/helpers/helpers'
    import cpvJson from '../achizitii-cheltuieli/cpv.json'
    import vSelect from "vue-select";
    import _ from "lodash";
    import { library } from "@fortawesome/fontawesome-svg-core";
    import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
    import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
    import {changeRoute, checkFormForInputs} from "../../../../../../helpers/helpers";
    import ChangeRoutePopup from "../ChangeRoutePopup";
    library.add(faFilePdf);
    export default {
        name: "CFPlanAchizitii",
        components: {
            CFTitle,
            BFormRadio,
            BFormInput,
            BFormCheckbox,
            BFormGroup,
            BFormDatepicker,
            BIconPlusCircleFill,
            BFormCheckboxGroup,
            BIconChevronUp,
            BIconChevronDown,
            BIconXCircleFill,
            BTooltip,
            ValidationProvider,
            ValidationObserver,
            FontAwesomeIcon,
            vSelect,
            ChangeRoutePopup
        },
        props:{
            data: {
                type: Object,
                default: null
            },
            m3GrantApplication: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                showModal: false,
                next: null,
                max: new Date(),
                tableLimited: true,
                completed: false,
                spendings: [],
                allSpendings: [],
                usedSpendings: [],
                unusedSpendings: false,
                cpvList: cpvJson,
                contractTypes: [
                    { label: 'Furnizare', value: 'furnizare' },
                    { label: 'Lucrări', value: 'lucrari' },
                    { label: 'Servicii', value: 'servicii' },
                ],
                options: [
                    { text: 'Orange', value: 'orange' },
                    { text: 'Apple', value: 'apple' },
                    { text: 'Pineapple', value: 'pineapple' },
                    { text: 'Grape', value: 'grape' }
                ],
                selected: []
            }
        },
        computed:{
            isCompleted() {
                return this.$store.getters['finantare/progress'].includes('Plan de achizitii');
            },
        },
        watch: {
            m3GrantApplication: {
                handler: function() {
                    this.initializePlanAchizitii()
                },
                deep: true
            },
            data: {
                handler: function() {
                    this.initializePlanAchizitii()
                },
                deep: true
            },
            isCompleted: {
                handler() {
                    this.completed = this.isCompleted;
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            this.initializePlanAchizitii()
        },
        beforeRouteLeave (to, from, next) {

            this.next = next;
            if(to.path === '/login' || to.path === '/logout')
                this.next();

            if(this.completed) {
                this.next();
            }
            else {
                if(checkFormForInputs())
                    this.showModal = true;
                else {
                    this.next();
                }
            }
        },
        methods: {
            leavePage(event){
                changeRoute(event, this.next);

                if(!event)
                    this.showModal = false;
            },
            initializePlanAchizitii() {
                this.allSpendings = [];
                this.spendings = [];
                if(this.m3GrantApplication && this.m3GrantApplication.plan_achizitii && this.data && this.data.m3_project && this.spendings.length < 1) {
                    this.spendings = this.m3GrantApplication.plan_achizitii
                    this.data.m3_project.spendings.forEach(category => {
                        if(category.subcategories){
                            category.subcategories.forEach(subcategory => {
                                if(subcategory.acquisitions) {
                                    subcategory.acquisitions.forEach(acquisition => {
                                        this.allSpendings.push(acquisition);
                                    })
                                }
                            })
                        }
                    })
                } else if(this.m3GrantApplication && !this.m3GrantApplication.plan_achizitii && this.data && this.data.m3_project && this.spendings.length < 1) {
                    this.data.m3_project.spendings.forEach(category => {
                        if(category.subcategories){
                            category.subcategories.forEach(subcategory => {
                                if(subcategory.acquisitions) {
                                    subcategory.acquisitions.forEach(acquisition => {
                                        this.allSpendings.push(acquisition);
                                    })
                                }
                            })
                        }
                    })
                }
                this.checkUsedSpendings()
                this.checkUnusedSpendings()
            },
            limitWords,
            removeCPV(spending, key) {
                if(!this.completed){
                    spending.cpv.splice(key, 1)
                } else {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                }
            },
            checkItemIsUsed(id){
                return this.usedSpendings.includes(id);
            },
            checkUsedSpendings() {
                this.allSpendings.forEach(userSpending => {
                    this.spendings.forEach(spending => {
                        if(!spending.acquisitionLimit){
                            if(spending.contract === 'lucrari')
                                spending.acquisitionLimit = 450200
                            else
                                spending.acquisitionLimit = 135060
                        }
                        spending.spendings.forEach(item => {
                            if(item.id === userSpending.acquisitionId && !this.usedSpendings.includes(userSpending.acquisitionId)) {
                                this.usedSpendings.push(userSpending.acquisitionId);
                            }
                        })
                    })
                })
            },
            limitInput(e) {
                if(e.length > 10) {
                    this.$toast.error('Poți selecta maxim 10 coduri CPV.')
                    e.pop()
                }
            },
            toggleUsed(item) {
                if(!this.completed){
                    if(this.usedSpendings.includes(item.acquisitionId)){
                        this.usedSpendings.splice(this.usedSpendings.indexOf(item.acquisitionId), 1)
                    }
                    else {
                        this.usedSpendings.push(item.acquisitionId);
                    }
                    this.checkUnusedSpendings()
                    this.$forceUpdate();
                } else {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                }

            },
            limitCharacters(key){
                if(this.spendings[key].description.length > 100) {
                    this.spendings[key].description = this.spendings[key].description.substring(0,100)
                    this.$toast.error('Numărul maxim de caractere este de 100.')
                }
            },
            // sortAllSpendings() {
            //
            //     let newSpendingsOrder = [];
            //     let usedAcquisitions = [];
            //     this.allSpendings.forEach(spending => {
            //         if(this.usedSpendings.includes(spending.acquisitionId)){
            //             usedAcquisitions.push(spending);
            //         }
            //         else {
            //             newSpendingsOrder.push(spending);
            //         }
            //     })
            //      this.allSpendings = newSpendingsOrder.concat(usedAcquisitions);
            //
            // },
            addSpending() {
                if(!this.completed){
                    this.spendings.push({
                        title: 'Modifică titlul achiziției',
                        contract: '',
                        description: '',
                        cpv: [],
                        spendings: [],
                        value: '',
                        type: 'Achiziție directă',
                        date_published: '',
                        date_published_result: '',
                        date_signed: '',
                        date_joue: '',
                        opened: true,
                        acquisitionLimit: 135060
                    })

                    document.getElementById('scrollAuxiliary').style.display = 'block';
                    this.$refs.scrollPlan.scrollIntoView({behavior: 'smooth', block: "end", inline: "nearest"});
                    document.getElementById('scrollAuxiliary').style.display = 'none';
                    // this.sortAllSpendings();
                } else {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                }
            },
            deleteSpending(key) {
                if(!this.completed){
                    this.spendings[key].spendings.forEach(item => {
                        let search = _.filter(this.allSpendings, v => v.description === item.description);
                        if(search.length > 0){
                            this.usedSpendings.splice(this.usedSpendings.indexOf(search[0].id), 1)
                        }
                        this.$forceUpdate();
                    })
                    this.spendings.splice(key, 1)
                } else {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.');
                }
            },
            getCPVCodes() {
                return this.cpvList.map((cpv) => {
                    return {
                        id: cpv.Cod_CPV,
                        label: cpv.Cod_CPV + ' - ' + cpv.Cod_CPV_descriere
                    }
                })
            },
            calculateTotalPrice(spending) {
                spending.value = spending.spendings.reduce((a, b) => +a + +b.total, 0);
                if(spending.value > spending.acquisitionLimit) {
                    spending.type = 'Procedură competitivă'
                } else {
                    spending.type = 'Achiziție directă'
                }
            },
            checkSpendingIncludes(spending, item) {
                let canEdit = true
                if(this.usedSpendings.includes(item.acquisitionId)) {
                    canEdit = false
                    if(_.filter(spending.spendings, v => v.description === item.description).length > 0){
                        canEdit = true
                    }
                }
                return canEdit
            },
            checkUnusedSpendings() {
                this.unusedSpendings = ! (this.allSpendings.length === this.usedSpendings.length)
            },
            sendForm(){
                if(this.completed){
                    if(this.spendings.length === 0){
                        this.completed = false
                        this.$toast.error('Te rugăm adaugă cel puțin o achiziție înainte de a salva.');
                    }
                    else{
                        this.$refs.formAchizitii.validate().then((e) => {
                            if (!e) {
                                this.completed = false
                                this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                            } else {
                                this.checkUnusedSpendings()
                                let sendForm;
                                sendForm = this.spendings
                                this.unusedSpendings = false
                                axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {plan_achizitii: sendForm})
                                    .then( () => {
                                        this.$emit('savedData')
                                        this.$store.dispatch('finantare/addToProgress', 'Plan de achizitii')
                                        this.$toast.success('Informațiile au fost salvate!')
                                    })
                            }
                        })
                    }
                }
                else{
                    this.$store.dispatch('finantare/removeFromProgress', 'Plan de achizitii')
                }
            }
        }
    }
</script>
<style>
table th.custom-smaller-width{
    width: 16% !important;
}
table th.value-field{
    width: 8% !important;
}
@media screen and (max-width: 1100px) {
    table th.custom-smaller-width{
        width: 30% !important;
    }
}
</style>
<style scoped>
.tooltip { top: 0; }
.table-responsive{
    overflow-x: inherit !important;
}
.subtitle{
    margin-top: 20px;
    font-size: 14px;
    color: #5f5b6e;
    font-weight: 500;
}
.small-item-table{
  display: flex;
  width: 100%;
  justify-content: center
}
.b-form-datepicker{
    color: #767a95;
    background: #e9ecef;
    font-size: 14px;
    font-weight: 700;
    padding: 0;
    max-height: 33px;
    border-radius: 2px;
}
.completed{
    background: #d1f5ea!important;
    color:#b2b6be!important;
    pointer-events: none;
}
.flex{
    display: flex;
}
.flex-column{
    display: flex;
    flex-direction: column;
}
.space-between{
    justify-content: space-between;
}
.items-center{
    align-items: center;
}
.document-download {
    background: #f8f8f8;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 315px;
    min-height: 115px;
    text-decoration: none;
    margin-left: 20px;
}
.document-info{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.document-download p{
    font-size: 14px;
    color: #5f5b6e;
    font-weight: 500;
}
.document-download svg{
    font-size: 35px;
    color: #545a6f;
    margin-right: 15px;
}
.bottom-pictures{
    display: flex;
    align-items: center;
    margin-top: 30px;
    flex-wrap: wrap;
}
.bottom-pictures img:first-child{
    margin-right: 40px;
}
.add-button{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    cursor: pointer;
    background: #49cda8;
    width: 100%;
    padding: 7px 10px;
    height: 100%;
    max-width: 220px;
    max-height: 40px;
    border-radius: 3px;
}
.purple-title-bar{
    background: #826d8a;
    padding: 10px 20px;
    min-height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.purple-title-bar h3{
    font-size: 16px;
    color: #fff;
    margin: 0;
}
.achizitie{
    margin-top: 20px;
}
.achizitie-header{
    background: #e9eaec;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    margin-bottom: 20px;
}
.achizitie-header h3{
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 0;
    color: #767a95;
}
.achizitie-header >>> .expand-icon{
    stroke: #49cda8;
    cursor: pointer;
    fill: #49cda8;
    margin-right: 10px;
}
.achizitie-header >>> .delete-icon{
    fill: #ea8196;
    cursor: pointer;
}
.left-input, .right-input{
    width: 48%;
}
.left-input span, .right-input span{
    width: 100%;
}
.v-select{
    border: 1px solid #ced4da;
}
.v-select >>> .vs__dropdown-menu {
    background: #e9ecef;
    max-height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
}
.v-select >>> .vs__dropdown-toggle{
    background: #e9ecef;
    margin: 0;
    border-radius: 2px;
    justify-content: space-between;
    align-items: center;
    max-height: 33px;
    border: none;
}
.v-select >>> .vs__actions{
    padding: 0;
}
.v-select >>> .vs__dropdown-option {
    color: #767a95;
    font-size: 13px;
    padding-left: 5px;
    font-weight: 600;
}
.v-select >>> .vs__search{
    margin: 0;
    padding: 0;
}
.v-select >>> .vs__selected{
    color: #767a95;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}
.v-select >>> .vs__selected-options {
    flex-wrap: nowrap;
    max-width: calc(100% - 10px);
}
.v-select >>> .vs__selected {
    display: flex;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100px;
    overflow: hidden;
    flex-direction: row-reverse !important;
    justify-content: flex-end;
    margin-top: 2px;
}
.hiddenValues >>> .vs__selected{
    display: none;
}
.delete-cpv{
    margin-left: 5px;
    color: var(--dangerColor);
    cursor: pointer;
}
.custom-legend{
    text-align: right;
    font-size: 12px !important;
    color: #777e90;
    font-weight: 500;
    max-width: 235px;
    width: 100%;
    padding-right: 5px;
    padding-left: 5px;
}
.spendings-box{
    border-radius: 2px;
    padding: 5px 10px;
    height: inherit;
    background: #e9ecef;
    width: 100%;
    display: flex;
    min-height: 150px;
    max-height: 150px;
    overflow: auto;
    flex-direction: column;
}
.completed-box{
    background: #d1f5ea!important;
}
.fake-input-group{
    display: flex;
    align-items: center;
}
.fake-input-group >>> label{
    font-size: 12px;
    color: #666c7b;
    font-weight: 500;
}
.fake-input-group >>> .custom-control-label::after, .fake-input-group >>> .custom-control-label::before{
    width: 0.9rem;
    height: 0.9rem;
    top: 0.35rem;
}
.fake-input-group .flex-price >>> label{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.fake-input-group .flex-price span:last-child{
    max-width: 90px;
    text-align: right;
}
.cpv-item{
    font-size: 14px;
}
.green-box{
    min-height: 33px;
    padding: 3px 10px;
    background: #c5e5dc;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
}
.green-box p{
    text-align: right;
    color: #666c7b;
    font-size: 15px;
}
.used-item{
    opacity: 0.6;
}
.no-actions{
    pointer-events: none;
}
.disabled-select{
    pointer-events: none;
}
.disabled-select >>> .vs__dropdown-toggle, .disabled-select >>> .vs__selected-options, .disabled-select >>> input{
    background: #d1f5ea!important;
    color:#b2b6be!important;
}
@media (min-width: 1980px) {
    .spendings-box, .green-box{
        max-width: 66%;
    }
    .fake-input-group{
        justify-content: flex-end;
    }
}
@media (max-width: 1770px) {
    .bottom-pictures img:first-child{
        margin-right: 40px;
        margin-bottom: 20px;
    }
}
@media (max-width: 1600px){
    .document-info{
        flex-direction: column;
        align-items: flex-start;
    }
    .document-download{
        margin-left: 0;
        max-width: 100%;
        margin-top: 10px;
    }
    .flex{
        flex-direction: column;
    }
    .left-input, .right-input{
        width: 100%;
    }
    .left-input >>> legend, .right-input >>> legend, .left-input .custom-legend, .right-input .custom-legend{
        max-width: 150px;
        text-align: left;
    }
    .v-select >>> .vs__dropdown-toggle{
        max-width: 100%;
    }
}
@media (max-width: 1500px) {
    .bottom-pictures img:first-child{
        margin-right: 0;
    }
}
@media (max-width: 1441px) {
    .fake-input-group{
        flex-direction: column;
        align-items: flex-start!important;
    }
}
</style>
